export default __webpack_public_path__ + "tmp_src/components/TagMenuDropdown/TagMenuDropdown.css.liquid";